import styled from "styled-components";
import { AktuelleNewsBlock } from "../../../../shared/blocks/AktuelleNewsBlock";
import { EventDatesBlock } from "../../../../shared/blocks/EventDatesBlock";
import { TimetableBlock } from "../../../../shared/blocks/TimetableBlock";
import { Tablist } from "../../../../shared/components/speed-recruiting/Tablist";
import { TestimonialsSection } from "../../../../shared/components/speed-recruiting/Testimonials";
import { TestimonialsSectionTalents } from "../../../../shared/components/speed-recruiting/TestimonialsTalents";
import {
  getBlogPostsByCategory,
  getEventsWithAgenturenQuery,
  getPageBlocks,
  getTestimonials,
  getTestimonialsTalents,
} from "../../../../shared/lib/api";
import {
  Container,
  ContainerContentFull,
  ContainerContentStandard,
  TablePromoContainer,
} from "../../../../shared/styles/container";
import { device } from "../../../../shared/styles/device";
import Layout from "../../components/global/Layout";
import Seo from "../../components/global/Seo";
import { AreasSection } from "../../components/speed-recruiting/Areas";
import CircleCharts from "../../components/speed-recruiting/CircleCharts";
import { MediaSection } from "../../components/speed-recruiting/Media";
import { ReasonSwiper } from "../../components/speed-recruiting/ReasonSwiper";
import { VideoHero } from "../../components/speed-recruiting/VideoHero";
import { theme } from "../../styles/theme";
import TalentpoolLogo from "/public/svg/Logo.svg";

const ContainerBGLight = styled.div`
  background: #f5f5f7;

  .testimonials-headline {
    margin-top: 64px;
    margin-bottom: 12px;
    color: #18191f;
    font-size: 28px;
    font-weight: 700;
    text-align: center;
    padding-left: 6px;
    padding-right: 6px;
    @media ${device.tablet} {
      text-align: left;
    }
  }
  .testimonials-subheadline {
    font-size: 16px;
    line-height: 26px;
    font-weight: 500;
    padding-left: 0px;
    padding-right: 0px;
    @media ${device.tablet} {
      font-size: 18px;
      padding-left: 6px;
      padding-right: 6px;
    }
  }
`;
const TextCenterContainer = styled.div`
  h2,
  h3 {
    text-align: center;
    padding-left: 6px;
    padding-right: 6px;
    @media ${device.tablet} {
      text-align: left;
    }
  }
`;

const SpeedRecruiting = ({
  featuredPosts,
  blocks,
  events,
  testimonials,
  testimonialsTalents,
  preview,
  successStories,
}) => {
  const description =
    "Beim STELL-MICH-EIN lernst du an einem Abend etwa 10 Top-Unternehmen der Kommunikationsbranche kennen. Wie beim klassischen Speeddating hast du die Möglichkeit, dich jeder Agentur in kurzer Zeit von deiner besten Seite zu zeigen. Natürlich haben auch die Agenturen die Chance, sich bei dir zu präsentieren. Alle 5 Minuten wechselst du den Tisch und lernst so 10 potenzielle Arbeitergeber*innen an nur einem Abend kennen. Schneller kann dein Talent nicht die Runde machen!";
  const title = "Speed-Recruiting | STELL-MICH-EIN";

  return (
    <>
      <Layout preview={preview} showCallToAction>
        <Seo
          title={title}
          description={description}
          imageSrc="https://stellmichein.de/images/speed-recruiting/speedrecruiting.png"
        />
        <Container>
          <ContainerContentStandard>
            <VideoHero />
          </ContainerContentStandard>
          <ContainerContentFull>
            <ContainerBGLight>
              <TextCenterContainer>
                <TestimonialsSectionTalents
                  headline={
                    <h2 className="testimonials-headline">
                      Teilnehmende sind begeistert
                    </h2>
                  }
                  subheadline={
                    <h3 className="testimonials-subheadline">
                      Das sagen ehemalige Bewerberinnen und Bewerber
                    </h3>
                  }
                  testmonials={testimonialsTalents}
                />
              </TextCenterContainer>
            </ContainerBGLight>
            <TablePromoContainer>
              {blocks.map((block) => {
                if (block.name === "lazyblock/speed-recruiting-event-termine") {
                  return (
                    <EventDatesBlock
                      key={block.name + block.order}
                      block={block}
                      LogoSvg={TalentpoolLogo}
                    ></EventDatesBlock>
                  );
                }
              })}
            </TablePromoContainer>
          </ContainerContentFull>
        </Container>
        <Container backgroundColor={theme.colors.lightBg}>
          <ContainerContentFull>
            <TablePromoContainer>
              {blocks.map((block) => {
                if (block.name === "lazyblock/speed-recruiting-timetable") {
                  return (
                    <TimetableBlock
                      key={block.name + block.order}
                      block={block}
                    ></TimetableBlock>
                  );
                }
              })}
            </TablePromoContainer>
            {blocks.map((block) => {
              if (block.name === "lazyblock/speed-recruiting-agenturen") {
                return (
                  <Tablist
                    key={block.name + block.order}
                    block={block}
                    events={events}
                  ></Tablist>
                );
              }
            })}
          </ContainerContentFull>

          <ContainerContentFull>
            <AreasSection />
            <ReasonSwiper />
            {/*   <ApplicationSwiper /> */}
          </ContainerContentFull>
          <ContainerContentStandard>
            <CircleCharts />
          </ContainerContentStandard>
          <ContainerContentFull>
            <TestimonialsSection
              headline={<h2>Das sagen die teilnehmenden Agenturen</h2>}
              subheadline={
                <h3>
                  Folgenden Agenturen konnten wir schon helfen: Jung von Matt,
                  Scholz & Friends, Serviceplan, Metadesign, Palmer Hargreaves,
                  Zum goldenen Hirschen, Ogilvy, Kolle Rebbe, und viele mehr!
                </h3>
              }
              testmonials={testimonials}
            />
          </ContainerContentFull>
          <ContainerContentFull>
            <AktuelleNewsBlock
              title="Success Stories"
              blogPosts={successStories.edges}
            />
            {/*  <FeaturedSection posts={featuredPosts.edges} /> */}
          </ContainerContentFull>
          <ContainerContentStandard>
            <MediaSection />
          </ContainerContentStandard>
        </Container>
      </Layout>
    </>
  );
};

export default SpeedRecruiting;

const getTime = (date?: Date) => {
  return date != null ? date.getTime() : 0;
};

export async function getStaticProps({ preview = false, previewData }) {
  const featuredPosts = await getBlogPostsByCategory(preview, "Featured");
  const successStories = await getBlogPostsByCategory(preview, "Success-Story");
  const blocks = await getPageBlocks("speed-recruiting", preview, previewData);
  const events = await getEventsWithAgenturenQuery();
  const testimonials = await getTestimonials();
  const testimonialsTalents = await getTestimonialsTalents();

  // sort ascending
  events.edges.sort((a: any, b: any) => {
    return getTime(a.date) > getTime(b.date) ? 1 : -1;
  });

  return {
    props: {
      featuredPosts,
      blocks,
      events,
      testimonials,
      testimonialsTalents,
      preview,
      successStories,
    },
    revalidate: 120,
  };
}
